import {
	Component,
	OnInit,
	ElementRef,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Inject
}
	from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { ThongTinHangVeService } from '../phieu-thong-tin-hang-ve-ver2-service/phieu-thong-tin-hang-ve-ver2.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { KeHoachHangVeTTHVService } from '../ke-hoach-hang-ve-service/ke-hoach-hang-ve.service';
//Model
import { DeNghiNhapKho, DeNghiNhapKhoChiTiet, KeHoachHangVe, FileDinhKem, DSFileImport, FileImport } from '../phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import moment from 'moment';
//Component
import { XacNhanKiemTraComponent } from '../xac-nhan-kiem-tra-dialog/xac-nhan-kiem-tra-dialog.component';

import { CommonConFig } from '../../../dung-chung/__model/common_config.model';

@Component({
	selector: 'm-gd-duyet-kq-kiem-tra-hang.component',
	templateUrl: './gd-duyet-kq-kiem-tra-hang.component.html',
	styleUrls: ['../phieu-thong-tin-hang-ve-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class GDDuyetKQKiemTraHangComponent implements OnInit {

	/*Config Form */
	CONFIG: CommonConFig;

    /* Comment columns mat-table
		Các trường columns cho bảng:
		- displayedColumns: display ra form
		- availableColumns: các cột sẽ được add vào display.
		- extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'QuyCach',
			displayName: 'Quy cách',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'TenDVT',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'Solo',
			displayName: 'Số lô',
			alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & CT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoPhieuDNMH',
            displayName: 'Số phiếu ĐNMH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoPhieuDH',
            displayName: 'Số phiếu ĐHM',
            alwaysChecked: false,
			isShow: true
		},
	
		{
			stt: 9,
			name: 'MaNCC',
			displayName: 'Mã NCC',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'TenNCC',
			displayName: 'Nhà cung cấp',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'TenNguoiNhanHang',
			displayName: 'Người nhận hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'TenPBKiemTra',
			displayName: 'Phòng ban kiểm tra',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'Ghichulohang',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'TenNguoiKiemTra',
			displayName: 'Người kiểm tra',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 14,
			name: 'Ngaykiemtra',
			displayName: 'Ngày kiểm tra',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'Quyetdinhlohang',
			displayName: 'Kết quả pass hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'SoLuongPhuHop',
			displayName: 'SL phù hợp',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'SoLuongKhongPhuHop',
			displayName: 'SL không phù hợp',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'QuyetDinhTra',
			displayName: 'Quyết định trả',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'SoLuongTraHang',
			displayName: 'SL trả',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 16,
			name: 'GhiChuKetQuaKiemTra',
			displayName: 'Ghi chú trả hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 16,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 17,
			name: 'KetQuaDuyet',
			displayName: 'TP kết quả duyệt',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 18,
			name: 'LyDo',
			displayName: 'TP Lý do',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 17,
			name: 'GDKetQuaDuyet',
			displayName: 'GĐCL kết quả duyệt',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 18,
			name: 'GDLyDo',
			displayName: 'GĐCL Lý do',
			alwaysChecked: false,
			isShow: true
		},
		{
		    stt: 99,
		    name: 'actions',
		    displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 100,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
        },
	];

	displayedFileTable = [];
	FileTableColumn = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'FileName',
			displayName: 'Tên tệp',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'GhiChu',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},

		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	/* End comment columns mat-table -------------------------------------*/

	/* Mat select search cho nhân viên nhận hàng - QC kiểm tra */
	listIdNV: any[] = [];
	selectIdNV: string = '';
	filteredIdNV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdNVFilterCtrl: string = '';
	haveElementIdNV: boolean = false;
	arrayNVForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */

	/* Danh sách trạng thái */
	listState: any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiNhapKhoChiTiet>(true, []);

	selectedFileTableColumns = new SelectionModel<any>(true, this.FileTableColumn);
	selectionFileTable = new SelectionModel<FileDinhKem>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    	// Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []		// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
	canEdit: boolean = true;			// Dialog có thể chỉnh sửa không?
	isSendPBKT: boolean = false;		// Gửi bộ phận mua hàng xác nhận?
	disableButton: boolean = true;		// Tắt nút thêm mới hàng khi chưa nhập đủ
	minDate: any;						// Lưu min date của ngày hiện tại
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	ThongTinHangVeForm: FormGroup;				//Form phiếu đề nghị
	hasFormErrors: boolean = false;

	FileForm: FormGroup;			//Form add hàng hóa cho phiếu

	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	thongTinHangVeItem: DeNghiNhapKho;

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị:  */
	listChiTietHangVe: DeNghiNhapKhoChiTiet[] = [];

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietHangVe: DeNghiNhapKhoChiTiet[] = [];

	returnListKeHoachHangVe: KeHoachHangVe[] = [];

	/*Xử lý File đính kèm */
	listFileName: string[] = [];
	listFileDinhKem: FileDinhKem[] = [];
	dataArray: FileImport[] = [];

	isShow:boolean=false;

	optionsTinhTrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'PTTHV_PHIEUMOI',
		},
		{
			id: 2,
			name: 'Chờ xử lý',
			value: 'PTTHV_CHOKQKT',
		},
		{
			id: 3,
			name: 'Hoàn tất',
			value: 'PTTHV_HOANTAT',
		},
		{
			id: 4,
			name: 'Đã hủy',
			value: 'PTTHV_DAHUY',
		}
	];

	@ViewChildren('inputnhaplydo')inputnhaplydo;
	constructor(
		public dialogRef: MatDialogRef<GDDuyetKQKiemTraHangComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private thongTinHangVeService: ThongTinHangVeService,
		private keHoachHangVeService: KeHoachHangVeTTHVService,
		private ThongTinHangVeFB: FormBuilder,
		private FileFB: FormBuilder,
		public dialog: MatDialog,
		private route: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef
	) {
		this.dialogRef.disableClose = true;
	}

	/** LOAD DATA */
	ngOnInit() {
		/*Get data from list when open dialog */
		this.thongTinHangVeItem = this.data.data;
		this.canEdit = this.data.canEdit;

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		/*Load all dropdown and create form */
		this.createForm();
		this.ListState();
		this.ListIdNv();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
		});

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
		this.applyFileTableColumns();
	}

	/*Create Form with appropriate sub forms */
	createForm() {
		
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.minDate = new Date();
		
		/*Group các Form */
		this.ThongTinHangVeForm = this.ThongTinHangVeFB.group({
			SoPhieu: [!(this.thongTinHangVeItem.Sophieu == undefined || this.thongTinHangVeItem.Sophieu == '') ? this.thongTinHangVeItem.Sophieu : '', Validators.required],
			NgayLapPhieu: [!(this.thongTinHangVeItem.Ngaynhap == undefined || this.thongTinHangVeItem.Ngaynhap == '') ? this.thongTinHangVeItem.Ngaynhap : new Date(), Validators.required],
			TenNguoiLap: [this.thongTinHangVeItem.IdDn > 0 ? this.thongTinHangVeItem.TenNguoitao : tenNguoiLap],
			TrangThai: [this.nameState],
			Nguoiduyet: [tenNguoiLap],
			Ngayduyet: [this.formatDatetime(this.minDate)],
			Lydokhongduyet:[this.thongTinHangVeItem.Lydokhongduyet]
		});
		
		/*Disable các trường dữ liệu không thay đổi */
		this.ThongTinHangVeForm.controls["SoPhieu"].disable();
		this.ThongTinHangVeForm.controls["NgayLapPhieu"].disable();
		this.ThongTinHangVeForm.controls["TenNguoiLap"].disable();
		this.ThongTinHangVeForm.controls["TrangThai"].disable();
		this.ThongTinHangVeForm.controls["Nguoiduyet"].disable();
		this.ThongTinHangVeForm.controls["Ngayduyet"].disable();

		/*Add dữ liệu chi tiết */
		if (this.thongTinHangVeItem.listChiTietNhapKho.length > 0) {
			this.listChiTietHangVe = this.thongTinHangVeItem.listChiTietNhapKho;
			this.tmpChiTietHangVe = [];
			for (let i = 0; i < this.listChiTietHangVe.length; i++) {
				let tmpElement = new DeNghiNhapKhoChiTiet();
				tmpElement.copy(this.listChiTietHangVe[i])
				
				if (tmpElement.Nguoinhanhang == 0) {
					tmpElement.Nguoinhanhang = +idUser
				}
				this.tmpChiTietHangVe.push(tmpElement);
			}

			this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];

			if (this.thongTinHangVeItem.listFileDinhKem != null
				&& this.thongTinHangVeItem.listFileDinhKem.length > 0) {
				this.listFileDinhKem = this.thongTinHangVeItem.listFileDinhKem;
				this.listFileDinhKem = [...this.listFileDinhKem];
			}
			//this.disableButton = this.isDisableCornFirmButton();
			this.disableButton = true;
		}
	}

	toggleboolean(){
		this.isShow=!this.isShow;
	}

	/*Lấy tiêu đề cho dialog*/
	getTitle(): string {
		return `GĐCL Duyệt kết quả pass hàng`;
	}

	/*Lấy tên theo id của quyết định */
	getNameOfQuyetDinhLoHang(Quyetdinhlohang: number) {
		if (Quyetdinhlohang == 0)
			return 'Pass nhập';
		else if (Quyetdinhlohang == 1)
			return 'Pass tạm nhập';
		else if (Quyetdinhlohang == 2)
			return 'Trả hàng';
		return '';
	}
	/*------------------------------------------------------ */

	/*Kiểm tra hàng */
	KiemTraHangHoa(item: any) {
		let tmpItem = new DeNghiNhapKhoChiTiet();
		tmpItem.copy(item);
		const dialogRef = this.dialog.open(XacNhanKiemTraComponent, {
			data: {
				data: tmpItem,
			},
		});

		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else {
				
				if (res.isChange) {
					let haveContain = false;
					for (let i = 0; i < this.tmpChiTietHangVe.length; i++) {
						if (this.tmpChiTietHangVe[i].IdCtdn == res.data.IdCtdn) {
							this.tmpChiTietHangVe.splice(i, 1);
							haveContain = true;
							break;
						}
					}
					if (haveContain) {
						this.tmpChiTietHangVe.push(res.data)
						this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
						this.disableButton = this.isDisableCornFirmButton();
						this.changeDetect.detectChanges();
					}
				}
			}
		});

	}
	isDisableCornFirmButton() {
		let condition = false;
		this.tmpChiTietHangVe.forEach(element => {
			if (element.Nguoikiemtra == null || element.Nguoikiemtra == undefined
				|| element.Nguoikiemtra == 0) {
				condition = true;
			}
		})
		return condition;
	}
	/*------------------------------------------------------------- */

	/*Lưu kết quả kiểm tra */
	onSubmit(status) {


		var controls=this.ThongTinHangVeForm.controls;
		if(status==1&&(controls["Lydokhongduyet"].value==""||controls["Lydokhongduyet"].value==null)){
			const message = `Vui lòng nhập lý do không duyệt.`;
			this.layoutUtilsService.showErorr(message);
			this.inputnhaplydo.first.nativeElement.focus();
			return ;
			
		}


		
		let _title: string = 'Xác nhận';
		let _description: string = `Bạn chắc chắn muốn ${this.exportContentPopup(status)} - Phiếu ${this.thongTinHangVeItem.Sophieu}?`;
		let _waitDesciption: string = 'Đang xác nhận...';
		let message = `Xác nhận thành công`;

		const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}

			
			 var controls=this.ThongTinHangVeForm.controls;
				this.thongTinHangVeItem.Tinhtrang = this.convertCodestatus(status);
				this.thongTinHangVeItem.Lydokhongduyet = controls["Lydokhongduyet"].value;
				
				this.thongTinHangVeService.updateOnlyThongTinHangVe(this.thongTinHangVeItem).subscribe(res => {
					if (res.status == 1) {
						this.layoutUtilsService.showInfo(message);
						this.isChange = true;
						this.saveAddedTTHV = [];
						this.saveAddedTTHV.push(this.thongTinHangVeItem.IdDn);
						this.back();
					}
					else {
						this.layoutUtilsService.showErorr(res.error.message);
					}
				});
			
		});
	}
	checkDisableConfirm() {
		
		for (let i = 0; i < this.tmpChiTietHangVe.length; i++) {
			if (this.tmpChiTietHangVe[i].Nguoikiemtra <= 0 || this.tmpChiTietHangVe[i].Ngaykiemtra == ""
				|| this.tmpChiTietHangVe[i].Quyetdinhlohang == -1) {
				this.disableButton = true;
				return null;
			}
		}
		this.disableButton = false;
		this.changeDetect.detectChanges();
	}
	saveSelectionItem(){
		if(this.selection.selected.length <= 0){
			this.layoutUtilsService.showErorr('Chưa có dữ liệu được chọn!');
			return;
		}

		for(let i = 0; i < this.selection.selected.length; i++){
			let element = this.selection.selected[i];
			let index = this.tmpChiTietHangVe.findIndex(x => x.IdCtdn == element.IdCtdn);
			if(index > -1){
				if (this.tmpChiTietHangVe[index].KetQuaDuyet == null) {
					this.layoutUtilsService.showErorr('Vui lòng chọn kết quả duyệt');
					return;
				}
				if (this.tmpChiTietHangVe[index].KetQuaDuyet == 2 
					&& (this.tmpChiTietHangVe[index].LyDo == null 
						|| this.tmpChiTietHangVe[index].LyDo == '')) {
					this.layoutUtilsService.showErorr('Vui lòng nhập lý do với trường hợp không duyệt');
					return;
				}
			}
			else{
				this.layoutUtilsService.showErorr('Lỗi duyệt chi tiết, vui lòng thử lại!');
				return;
			}
		}
		
		for(let i = 0; i < this.selection.selected.length; i++){
			let element = this.selection.selected[i];
			let index = this.tmpChiTietHangVe.findIndex(x => x.IdCtdn == element.IdCtdn);
			if(index > -1){
				if (this.tmpChiTietHangVe[index].KetQuaDuyet == null) {
					this.layoutUtilsService.showErorr('Vui lòng chọn kết quả duyệt');
					break;
				}
				if (this.tmpChiTietHangVe[index].KetQuaDuyet == 2 
					&& (this.tmpChiTietHangVe[index].LyDo == null 
						|| this.tmpChiTietHangVe[index].LyDo == '')) {
					this.layoutUtilsService.showErorr('Vui lòng nhập lý do với trường hợp không duyệt');
					break;
				}
				this.tmpChiTietHangVe[index].KetQuaDuyet = +this.tmpChiTietHangVe[index].KetQuaDuyet;	
				this.thongTinHangVeService.GDXacNhanTungHang(this.tmpChiTietHangVe[index]).subscribe(res => {
					if (res.status == 1) {
						
						this.tmpChiTietHangVe[index].TrangThaiPassHang = res.data.TrangThaiPassHang;
						this.isChange = true;
						this.thongTinHangVeService.getThongTinHangVeHistory(this.thongTinHangVeItem.IdDn).subscribe(res => {
							if (res.status == 1){
								this.thongTinHangVeItem.listDenghinhapkhoLsthaotac = res.data
								this.changeDetect.detectChanges();
							}
						});	
						this.changeDetect.detectChanges();
					}
					else {
						this.layoutUtilsService.showErorr(res.error.message);
					}
				});	
			}
			else{
				this.layoutUtilsService.showErorr('Lỗi duyệt chi tiết, vui lòng thử lại!');
				return;
			}
		}
	}
	saveItem(index: any){
		if (this.tmpChiTietHangVe[index].KetQuaDuyet == null) {
			this.layoutUtilsService.showErorr('Vui lòng chọn kết quả duyệt');
			return;
		}
		if (this.tmpChiTietHangVe[index].KetQuaDuyet == 2 
			&& (this.tmpChiTietHangVe[index].LyDo == null 
				|| this.tmpChiTietHangVe[index].LyDo == '')) {
			this.layoutUtilsService.showErorr('Vui lòng nhập lý do với trường hợp không duyệt');
			return;
		}

		const dialogRef = this.layoutUtilsService.POP02('');
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.tmpChiTietHangVe[index].KetQuaDuyet = +this.tmpChiTietHangVe[index].KetQuaDuyet;	
			this.thongTinHangVeService.GDXacNhanTungHang(this.tmpChiTietHangVe[index]).subscribe(res => {
				if (res.status == 1) {
					const message='Duyệt phiếu thành công';
					this.layoutUtilsService.showInfo(message);
					this.tmpChiTietHangVe[index].TrangThaiPassHang = res.data.TrangThaiPassHang;
					this.isChange = true;
				
					this.thongTinHangVeService.getThongTinHangVeHistory(this.thongTinHangVeItem.IdDn).subscribe(res => {
						if (res.status == 1){
							this.thongTinHangVeItem.listDenghinhapkhoLsthaotac = res.data
							this.changeDetect.detectChanges();
						}
					});	

					this.changeDetect.detectChanges();
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});	
		});
	
	}
	getHistory(idDetail: any, type: number){
		let item = this.thongTinHangVeItem.listDenghinhapkhoLsthaotac.find(x => x.DeNghiNhapKhoCtId == idDetail 
																				&& x.LoaiThaoTac == DeNghiNhapKhoChiTiet.optionTrangThaiDetail[3].value)
	
		if(item != null && type == 0){
			return item.NoiDung
		}
		else if(item != null && type == 1){
			return item.GhiChu;
		}
		return '';
	}
	getHistoryHT(idDetail: any, type: number){
		let item = this.thongTinHangVeItem.listDenghinhapkhoLsthaotac.find(x => x.DeNghiNhapKhoCtId == idDetail 
																				&& x.LoaiThaoTac == DeNghiNhapKhoChiTiet.optionTrangThaiDetail[4].value)
	
		if(item != null && type == 0){
			return item.NoiDung
		}
		else if(item != null && type == 1){
			return item.GhiChu;
		}
		return '';
	}
	/*------------------------------------------------------------- */

	/*------------------ begin xử lý trạng thái--------------------- */
	exportContentPopup(status){
		switch (status) {
			case 1:
				return 'không duyệt'
				
			case 2:
					return 'duyệt'
			default:
				break;
		}
	
	}
	convertCodestatus(status){
		switch (status) {
			case 1:
				return 'PTTHV_KHONGDUYET'
				
			case 2:
					return 'PTTHV_HOANTAT'
			default:
				break;
	}
	}
	/*------------------  end xử lý trạng thái--------------------- */

	/*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	applyFileTableColumns() {
		let _selectedColumns = this.selectedFileTableColumns.selected;
		this.selectedFileTableColumns = new SelectionModel<any>(true, this.FileTableColumn);
		for (let i = 0; i < this.FileTableColumn.length; i++) {
			this.selectedFileTableColumns.toggle(this.FileTableColumn[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.FileTableColumn[i].name == _selectedColumns[j].name) {
					this.selectedFileTableColumns.toggle(this.FileTableColumn[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedFileTableColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedFileTable = _applySelectedColumns;
	}
	getNumOfCanSelected(){
		var count = 0;
		this.tmpChiTietHangVe.forEach(x => {
			if(x.TrangThaiPassHang == DeNghiNhapKhoChiTiet.optionTrangThaiDetail[3].value){
				count++;
			}
		})
		return count;
	}
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.getNumOfCanSelected();
		return numSelected === numRows;
	}
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpChiTietHangVe.forEach(row => {
				if(row.TrangThaiPassHang == DeNghiNhapKhoChiTiet.optionTrangThaiDetail[3].value){
					this.selection.select(row)
				}			
			});
		}
	}
	/*---------------------------------------------------------------------------------------- */

	ListIdNv() {
		var phongban = '';
		this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
		this.keHoachHangVeService.listNV().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listIdNV = res.data;
				this.listChiTietHangVe.forEach(element => {
					let filterTmp = new ReplaySubject<any[]>(1)
					filterTmp.next(this.listIdNV.slice());
					this.arrayNVForEachHH.push(filterTmp);
				})
				this.changeDetect.detectChanges();
			};
		});
	}

	filterIdNv(item: any) {
		if (!this.listIdNV) {
			return;
		}
		// get the search keyword
		let search = this.IdNVFilterCtrl;
		let index = this.tmpChiTietHangVe.indexOf(item)

		if (!search) {
			this.arrayNVForEachHH[index].next(this.listIdNV.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if (index > -1) {
			this.arrayNVForEachHH[index].next(this.listIdNV.filter(ts =>
				ts.TenNV.toLowerCase().indexOf(search) > -1)
			);
		}
		this.changeDetect.detectChanges();
	}
	/*------------------------------------------ */

	/*Hàm lấy danh sách trạng thái phiếu*/
	ListState() {
		this.keHoachHangVeService.listState().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetect.detectChanges();
			};
		});
	}
	checkState() {
		this.listState.forEach(element => {
			if (element.Code == this.thongTinHangVeItem.Tinhtrang) {
				this.nameState = element.Description;
				if (this.ThongTinHangVeForm != null)
					this.ThongTinHangVeForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}
	getTrangThaiDetail(state: string){
		let item = DeNghiNhapKhoChiTiet.optionTrangThaiDetail.find(x => x.value == state)
		if(item != null){
			return item.name;
		}
		return '';
	}
	/*---------------------------------------- */

	/*Các hàm hỗ trợ cho thay đổi - cập nhập dữ liệu trên bảng*/
	canUpdateElementOnGrid(item: any) {
		if (this.canEdit && !this.thongTinHangVeItem.isQCKiemTra && (item.Nguoikiemtra == undefined || item.Nguoikiemtra == 0)) {
			return true;
		}
		else if (this.canEdit && this.thongTinHangVeItem.isQCKiemTra) {
			if (item.Nguoikiemtra == undefined || item.Nguoikiemtra == 0) {
				return true;
			}
		}
		return false;
	}
	changeValueOfColumn(columnName: string, item: any, event: any, afterUpdate: boolean) {
		if (columnName == 'Soluongchungtu') {
			if (afterUpdate)
				this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu = this.formatNumber(item.Soluongchungtu);
			else if (!afterUpdate && this.ValidateChangeNumberEvent(columnName, item, event)) {
				this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu = '' + Number(event.target.value.trim().replace(/,/g, ""));
				let index = this.data.selected.findIndex(x => x.Id == this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].IdDHCT);
				this.data.selected[index].SoLuong = Number(event.target.value.trim().replace(/,/g, ""));
			}
		}

		if (columnName == 'Solo') {
			if (afterUpdate)
				this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo = item.Solo
			else if (!afterUpdate) {
				this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo = event.target.value.trim();
				//this.updateValueColumn('Solo',item);
			}
		}

		if (columnName == 'Ghichulohang') {
			if (afterUpdate)
				this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Ghichulohang = item.Ghichulohang
			else if (!afterUpdate) {
				this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Ghichulohang = event.target.value.trim();
				//this.updateValueColumn('Ghichulohang',item);
			}
		}
	}
	isChangeValueOfColumn(columnName: string, item: any) {
		if (columnName == 'Solo' && this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo != this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo)
			return true;
		if (columnName == 'Soluongchungtu' && this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu != this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu)
			return true;

		return false;
	}
	updateValueColumn(columnName: string, item: any) {
		this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
	}
	resetValueUpdate(columnName: string, item: any) {
		if (columnName == 'Soluongchungtu') {
			this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu = this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu;
		}
		if (columnName == 'Solo') {
			this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo = this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo;
		}
	}
	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		return true;
	}
	/*---------------------------------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng số trên form*/
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == '.') {
					count += 1;
				}
			}
		}
		else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == '.') {
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	/*------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = '') {
		if (v == null || v == undefined || v == '')
			return '';
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, item: any) {
		
		let d1 = new Date(p_Val);
		let d2 = new Date();

		if (d1.getTime() < d2.getTime()) {
			this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Ngaykiemtra = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
		}
		this.changeDetect.detectChanges();
	}
	formatDatetime(datetime){
		if(datetime == null || datetime == '')	return '';
		return moment(datetime).format("DD/MM/YYYY");
	}
	/*------------------------------------------------------------- */

	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back() {
		this.dialogRef.close(
			{
				isChange: this.isChange,		//Dữ liệu có thay đổi hay không?
				dataAdd: this.returnListKeHoachHangVe,
				PTTHVNew: this.saveAddedTTHV
			}
		);
	}
	/*------------------------------------------------------------- */

	checkWarningState(item: DeNghiNhapKhoChiTiet){
		var tmp = Number(item.Soluongkehoach) * item.DungSai / 100;
		var result = -1;

		if(Number(item.Soluongchungtu) > Number(item.Soluongkehoach) + tmp){
			result = 0;
		}
		if((Number(item.Soluongkehoach) - tmp) <= Number(item.Soluongchungtu)
		&& (Number(item.Soluongchungtu) <= Number(item.Soluongkehoach) + tmp)){
			result = 1;
		}
		if(Number(item.Soluongchungtu) < Number(item.Soluongkehoach) - tmp){
			result = 2;
		}
		return result;
	}
	warningState(item: DeNghiNhapKhoChiTiet ){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return '> dung sai cho phép';
			case 1:
				return 'Thuộc dung sai cho phép';
			case 2:
				return '< dung sai cho phép';
			default:
				return ''
		}
	}
	cssWarningState(item:DeNghiNhapKhoChiTiet){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return 'red';
			case 1:
				return 'green';
			case 2:
				return 'orange';
			default:
				return ''
		}
	}

}